export const ADMINS_FETCH_FAIL = "ADMINS_FETCH_FAIL";
export const ADMINS_FETCH_SUCCESS = "ADMINS_FETCH_SUCCESS";
export const BACKUP_RESTORE_FAIL = "BACKUP_RESTORE_FAIL";
export const BACKUP_RESTORE_SUCCESS = "BACKUP_RESTORE_SUCCESS";
export const CLEAR_TOOLS_ERROR = "CLEAR_TOOLS_ERROR";
export const CLOSE_ALL_MODALS = "CLOSE_ALL_MODALS";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const CREATE_ADMIN_FAIL = "CREATE_ADMIN_FAIL";
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS";
export const CREATE_CELEBRATION_FAIL = "CREATE_CELEBRATION_FAIL";
export const CREATE_CELEBRATION_SUCCESS = "CREATE_CELEBRATION_SUCCESS";
export const CREATE_SUPPLY_DISTRIBUTION_SITE_FAIL = "CREATE_SUPPLY_DISTRIBUTION_SITE_FAIL";
export const CREATE_SUPPLY_DISTRIBUTION_SITE_SUCCESS = "CREATE_SUPPLY_DISTRIBUTION_SITE_SUCCESS";
export const CREATE_TOWN_FAIL = "CREATE_TOWN_FAIL";
export const CREATE_TOWN_SUCCESS = "CREATE_TOWN_SUCCESS";
export const CREATE_TRASH_COLLECTION_SITE_FAIL = "CREATE_TRASH_COLLECTION_SITE_FAIL";
export const CREATE_TRASH_COLLECTION_SITE_SUCCESS = "CREATE_TRASH_COLLECTION_SITE_SUCCESS";
export const CREATE_TRASH_DROP_FAIL = "CREATE_TRASH_DROP_FAIL";
export const CREATE_TRASH_DROP_SUCCESS = "CREATE_TRASH_DROP_SUCCESS";
export const CREATE_USER_FAIL = "CREATE_USER_FAIL";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const DELETE_ADMIN_FAIL = "DELETE_ADMIN_FAIL";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_CELEBRATION_FAIL = "DELETE_CELEBRATION_FAIL";
export const DELETE_CELEBRATION_SUCCESS = "DELETE_CELEBRATION_SUCCESS";
export const DELETE_FAQ_FAIL = "DELETE_FAQ_FAIL";
export const DELETE_FAQ_SUCCESS = "DELETE_FAQ_SUCCESS";
export const DELETE_SUPPLY_DISTRIBUTION_SITE_FAIL = "DELETE_SUPPLY_DISTRIBUTION_SITE_FAIL";
export const DELETE_SUPPLY_DISTRIBUTION_SITE_SUCCESS = "DELETE_SUPPLY_DISTRIBUTION_SITE_SUCCESS";
export const DELETE_TOWN_FAIL = "DELETE_TOWN_FAIL";
export const DELETE_TOWN_SUCCESS = "DELETE_TOWN_SUCCESS";
export const DELETE_TRASH_COLLECTION_SITE_FAIL = "DELETE_TRASH_COLLECTION_SITE_FAIL";
export const DELETE_TRASH_COLLECTION_SITE_SUCCESS = "DELETE_TRASH_COLLECTION_SITE_SUCCESS";
export const DELETE_TRASH_DROP_FAIL = "DELETE_TRASH_DROP_FAIL";
export const DELETE_TRASH_DROP_SUCCESS = "DELETE_TRASH_DROP_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DATA_LISTENERS_SETUP_FAIL = "DATA_LISTENERS_SETUP_FAIL";
export const DATA_LISTENERS_SETUP_SUCCESS = "DATA_LISTENERS_SETUP_SUCCESS";
export const ERROR = "ERROR";
export const FETCH_CELEBRATIONS_FAIL = "FETCH_CELEBRATIONS_FAIL";
export const FETCH_CELEBRATIONS_SUCCESS = "FETCH_CELEBRATIONS_SUCCESS";
export const FETCH_EVENT_INFO_FAIL = "FETCH_EVENT_INFO_FAIL";
export const FETCH_EVENT_INFO_SUCCESS = "FETCH_EVENT_INFO_SUCCESS";
export const FETCH_FAQS_FAIL = "FETCH_FAQS_FAIL";
export const FETCH_FAQS_SUCCESS = "FETCH_FAQS_SUCCESS";
export const FETCH_MESSAGES_FAIL = "FETCH_MESSAGES_FAIL";
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS";
export const FETCH_PERMISSIONS_FAIL = "FETCH_PERMISSIONS_FAIL";
export const FETCH_PERMISSIONS_SUCCESS = "FETCH_PERMISSIONS_SUCCESS";
export const FETCH_SUPPLY_DISTRIBUTION_SITES_FAIL = "FETCH_SUPPLY_DISTRIBUTION_SITES_FAIL";
export const FETCH_SUPPLY_DISTRIBUTION_SITES_SUCCESS = "FETCH_SUPPLY_DISTRIBUTION_SITES_SUCCESS";
export const FETCH_TEAM_MEMBERS_FAIL = "FETCH_TEAM_MEMBERS_FAIL";
export const FETCH_TEAM_MEMBERS_SUCCESS = "FETCH_TEAM_MEMBERS_SUCCESS";
export const FETCH_TEAMS_FAIL = "FETCH_TEAMS_FAIL";
export const FETCH_TEAMS_SUCCESS = "FETCH_TEAMS_SUCCESS";
export const FETCH_TOWNS_FAIL = "FETCH_TOWNS_FAIL";
export const FETCH_TOWNS_SUCCESS = "FETCH_TOWNS_SUCCESS";
export const FETCH_TRASH_COLLECTION_SITES_FAIL = "FETCH_TRASH_COLLECTION_SITES_FAIL";
export const FETCH_TRASH_COLLECTION_SITES_SUCCESS = "FETCH_TRASH_COLLECTION_SITES_SUCCESS";
export const FETCH_TRASH_DROPS_FAIL = "FETCH_TRASH_DROPS_FAIL";
export const FETCH_TRASH_DROPS_SUCCESS = "FETCH_TRASH_DROPS_SUCCESS";
export const FETCH_USERS_FAIL = "FETCH_USERS_FAIL";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const INITIALIZE_FAIL = "INITIALIZE_FAIL";
export const INITIALIZE_SUCCESS = "INITIALIZE_SUCCESS";
export const IS_BUSY = "IS_BUSY";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_RESET = "LOGIN_RESET";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const MESSAGE_SENT_FAIL = "MESSAGE_SENT_FAIL";
export const MESSAGE_SENT_SUCCESS = "MESSAGE_SENT_SUCCESS";
export const MESSAGE_SENT_RESET = "MESSAGE_SENT_RESET";
export const OPEN_MODAL = "OPEN_MODAL";
export const OPEN_MODAL_EXCLUSIVE = "OPEN_MODAL_EXCLUSIVE";
export const QUERY_CELEBRATIONS_FAIL = "QUERY_CELEBRATIONS_FAIL";
export const QUERY_CELEBRATIONS_SUCCESS = "QUERY_CELEBRATIONS_SUCCESS";
export const QUERY_FAQS_FAIL = "QUERY_FAQS_FAIL";
export const QUERY_FAQS_SUCCESS = "QUERY_FAQS_SUCCESS";
export const QUERY_SUPPLY_DISTRIBUTION_SITES_FAIL = "QUERY_SUPPLY_DISTRIBUTION_SITES_FAIL";
export const QUERY_SUPPLY_DISTRIBUTION_SITES_SUCCESS = "QUERY_SUPPLY_DISTRIBUTION_SITES_SUCCESS";
export const QUERY_TOWNS_FAIL = "QUERY_TOWNS_FAIL";
export const QUERY_TOWNS_SUCCESS = "QUERY_TOWNS_SUCCESS";
export const QUERY_TRASH_COLLECTION_SITES_FAIL = "QUERY_TRASH_COLLECTION_SITES_FAIL";
export const QUERY_TRASH_COLLECTION_SITES_SUCCESS = "QUERY_TRASH_COLLECTION_SITES_SUCCESS";
export const RESET = "RESET";
export const RESET_PASSWORD_CLEAR = "RESET_PASSWORD_CLEAR";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const SAVE_CELEBRATION_FAIL = "SAVE_CELEBRATION_FAIL";
export const SAVE_CELEBRATION_SUCCESS = "SAVE_CELEBRATION_SUCCESS";
export const SAVE_FAQ_FAIL = "SAVE_FAQ_FAIL";
export const SAVE_FAQ_SUCCESS = "SAVE_FAQ_SUCCESS";
export const SAVE_SUPPLY_DISTRIBUTION_SITE_FAIL = "SAVE_SUPPLY_DISTRIBUTION_SITE_FAIL";
export const SAVE_SUPPLY_DISTRIBUTION_SITE_SUCCESS = "SAVE_SUPPLY_DISTRIBUTION_SITE_SUCCESS";
export const SAVE_TRASH_COLLECTION_SITE_FAIL = "SAVE_TRASH_COLLECTION_SITE_FAIL";
export const SAVE_TRASH_COLLECTION_SITE_SUCCESS = "SAVE_TRASH_COLLECTION_SITE_SUCCESS";
export const SELECT_ADMIN = "SELECT_ADMIN";
export const SELECT_CELEBRATION = "SELECT_CELEBRATION";
export const SELECT_SUPPLY_DISTRIBUTION_SITE = "SELECT_SUPPLY_DISTRIBUTION_SITE";
export const SELECT_TOWN = "SELECT_TOWN";
export const SELECT_USER = "SELECT_USER";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const SELECT_TRASH_COLLECTION_SITE = "SELECT_TRASH_COLLECTION_SITE";
export const SELECT_TRASH_DROP = "SELECT_TRASH_DROP";
export const UPDATE_ADMIN_FAIL = "UPDATE_ADMIN_FAIL";
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_CELEBRATION_FAIL = "UPDATE_CELEBRATION_FAIL";
export const UPDATE_CELEBRATION_SUCCESS = "UPDATE_CELEBRATION_SUCCESS";
export const UPDATE_EVENT_INFO_FAIL = "UPDATE_EVENT_INFO_FAIL";
export const UPDATE_EVENT_INFO_SUCCESS = "UPDATE_EVENT_INFO_SUCCESS";
export const UPDATE_SUPPLY_DISTRIBUTION_SITE_FAIL = "UPDATE_SUPPLY_DISTRIBUTION_SITE_FAIL";
export const UPDATE_SUPPLY_DISTRIBUTION_SITE_SUCCESS = "UPDATE_SUPPLY_DISTRIBUTION_SITE_SUCCESS";
export const UPDATE_SETTINGS_SUCCESS = "UPDATE_SETTINGS_SUCCESS";
export const UPDATE_SETTINGS_FAIL = "UPDATE_SETTINGS_FAIL";
export const UPDATE_TOWN_FAIL = "UPDATE_TOWN_FAIL";
export const UPDATE_TOWN_SUCCESS = "UPDATE_TOWN_SUCCESS";
export const UPDATE_TRASH_COLLECTION_SITE_FAIL = "UPDATE_TRASH_COLLECTION_SITE_FAIL";
export const UPDATE_TRASH_COLLECTION_SITE_SUCCESS = "UPDATE_TRASH_COLLECTION_SITE_SUCCESS";
export const UPDATE_TRASH_DROP_FAIL = "UPDATE_TRASH_DROP_FAIL";
export const UPDATE_TRASH_DROP_SUCCESS = "UPDATE_TRASH_DROP_SUCCESS";
export const UPDATE_USER_FAIL = "UPDATE_USER_FAIL";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_TEAM_FAIL = "UPDATE_TEAM_FAIL";
export const UPDATE_TEAM_SUCCESS = "UPDATE_TEAM_SUCCESS";

